import { VooiLineaProvider } from '../../providers/dexes/linea/vooi/vooi-provider';

export const vooiTradeProviders = [VooiLineaProvider];
